import { PdfBuilderLocation } from "../../Enums/ChoiceEnums";
import { deleteVoid, getObject, postObject } from "../ChoiceApi";
import { IPdfJoin, IPdfJoinResponse, IPdfSpitSave, IPdfSpitSendMessage, IPdfSplitAuditResponse, IPdfSplitResponse, IPdfSplitSaveResponse, IPdfSplitSendMessageResponse } from "../Models/PdfSplitModel";

export async function faxSplit(location: PdfBuilderLocation, recordId: number): Promise<IPdfSplitResponse|undefined> {
    return getObject(`apipdf/FaxSplit/${location}/${recordId}`);
}

export async function pdfJoin(payload: IPdfJoin): Promise<IPdfJoinResponse|undefined> {
    return postObject("apipdf/PdfJoin", payload);
}

export async function pdfSplitSave(payload: IPdfSpitSave): Promise<IPdfSplitSaveResponse|undefined> {
        return postObject("apipdf/PdfSplitSave", payload);
}

export async function pdfSplitAudit(location: PdfBuilderLocation, recordId: number): Promise<IPdfSplitAuditResponse|undefined> {
    return getObject(`apipdf/PdfSplitAudit/${location}/${recordId}`);
}

export async function faxReceiveDelete(recordId: number) {
    // TODO: Move to deleteVoidWithBooleanResult
    await deleteVoid(`apipdf/FaxReceiveDelete/${recordId}`);
}

export async function SendMessage(payload: IPdfSpitSendMessage): Promise<IPdfSplitSendMessageResponse|undefined> {
    return postObject("apipdf/PdfSplitSendMessage", payload);
}